import { render, staticRenderFns } from "./Sandbox_wuhan.vue?vue&type=template&id=d55512be&scoped=true"
import script from "./Sandbox_wuhan.vue?vue&type=script&lang=js"
export * from "./Sandbox_wuhan.vue?vue&type=script&lang=js"
import style0 from "./Sandbox_wuhan.vue?vue&type=style&index=0&id=d55512be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55512be",
  null
  
)

export default component.exports